import { FSMCommonStatePaths } from '../../../../../FSM/shared/routes'
import { StateRoute } from '../../../../../types/interface/fsm.interface'
import { QB_CLOSED } from '../shared/closedConfig'
import QBClosedPage from '../../../components/QBClosedPage'

export const FSMContentStatePathsNO: Array<StateRoute> = [
  ...FSMCommonStatePaths,
  { is: QB_CLOSED, page: QBClosedPage },
]
